// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2Opna","obliqueLineWrap":"membershipbadge_obliqueLineWrap__17-6a","obliqueLine":"membershipbadge_obliqueLine__2xgq-"};